import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
import Image from 'next/image';
import { Box, Button, Divider, Grid, Stack, Typography, useTheme } from '@mui/material';
import { SelectOptions } from './types';
import logoDark from '../../public/logoDark.svg';
import logoLight from '../../public/logoLight.svg';
import { BgImage } from './types';
import LoginWithAzure from './LoginWithAzure';
import LoginWithLdap from './LoginWithLdap';
import LoginWithKua from './LoginWithKua';
import RequestAccess from './RequestAccess';
type Props = {
  signInOptions: {
    azureAD: {
      enabled: boolean;
      callback: () => void;
    };
    credentialsLDAP: {
      enabled: boolean;
      callback: (email: string, passord: string) => Promise<boolean>;
    };
    credentialsKUA: {
      enabled: boolean;
      callback: (email: string, passord: string) => Promise<boolean>;
    };
  };
  options: SelectOptions;
  requestAccessUrl: string;
  requestAccessEnabled: boolean;
};
export const KeystoneSigninScreen = t0 => {
  const $ = _c(43);
  const {
    signInOptions,
    options,
    requestAccessUrl,
    requestAccessEnabled
  } = t0;
  const theme = useTheme();
  const [showRequestAccess, setShowRequestAccess] = useState(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      showComponent: "",
      showAbort: false,
      showAzure: false,
      showAzureWithMore: false,
      showLDAP: false,
      showLDAPWithMore: false,
      showKUA: false,
      hasAzure: false,
      hasLDAP: false,
      hasKUA: false
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [state, setState] = useState(t1);
  let t2;
  if ($[1] !== signInOptions.azureAD.enabled || $[2] !== signInOptions.credentialsKUA.enabled || $[3] !== signInOptions.credentialsLDAP.enabled) {
    t2 = () => {
      let showMain = "";
      if (signInOptions.azureAD.enabled) {
        showMain = "azure";
      } else {
        if (signInOptions.credentialsLDAP.enabled) {
          showMain = "ldap";
        } else {
          if (signInOptions.credentialsKUA.enabled) {
            showMain = "kua";
          }
        }
      }
      let signInOptionsCount = 0;
      if (signInOptions.azureAD.enabled) {
        signInOptionsCount++;
      }
      if (signInOptions.credentialsLDAP.enabled) {
        signInOptionsCount++;
      }
      if (signInOptions.credentialsKUA.enabled) {
        signInOptionsCount++;
      }
      setState({
        showComponent: "",
        showAbort: signInOptionsCount > 1,
        showAzure: signInOptions.azureAD.enabled && showMain == "azure",
        showAzureWithMore: signInOptions.azureAD.enabled && (signInOptions.credentialsLDAP.enabled || signInOptions.credentialsKUA.enabled),
        showLDAP: signInOptions.credentialsLDAP.enabled && showMain == "ldap",
        showLDAPWithMore: signInOptions.credentialsLDAP.enabled && signInOptions.credentialsKUA.enabled,
        showKUA: signInOptions.credentialsKUA.enabled && showMain == "kua",
        hasAzure: signInOptions.azureAD.enabled,
        hasLDAP: signInOptions.credentialsLDAP.enabled,
        hasKUA: signInOptions.credentialsKUA.enabled
      });
    };
    $[1] = signInOptions.azureAD.enabled;
    $[2] = signInOptions.credentialsKUA.enabled;
    $[3] = signInOptions.credentialsLDAP.enabled;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== signInOptions) {
    t3 = [signInOptions];
    $[5] = signInOptions;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  useEffect(t2, t3);
  let t4;
  if ($[7] !== state) {
    t4 = component => {
      setState({
        ...state,
        showComponent: component
      });
    };
    $[7] = state;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const onShowCompoentHandler = t4;
  let t5;
  if ($[9] !== signInOptions.azureAD) {
    t5 = async () => signInOptions.azureAD?.callback();
    $[9] = signInOptions.azureAD;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const onLoginHandlerAzure = t5;
  let t6;
  if ($[11] !== signInOptions.credentialsKUA) {
    t6 = async (email, password) => signInOptions.credentialsKUA?.callback(email, password);
    $[11] = signInOptions.credentialsKUA;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  const onLoginHandlerKUA = t6;
  let t7;
  if ($[13] !== signInOptions.credentialsLDAP) {
    t7 = async (email_0, password_0) => signInOptions.credentialsLDAP?.callback(email_0, password_0);
    $[13] = signInOptions.credentialsLDAP;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  const onLoginHandlerLDAP = t7;
  let t8;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      height: "100vh",
      width: {
        xs: "100%",
        sm: "500px"
      }
    };
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = {
      height: "100vh",
      justifyContent: "space-between"
    };
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = {
      width: "80%",
      margin: "0 auto",
      mt: 7
    };
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = {
      textAlign: "center",
      paddingTop: 8,
      paddingBottom: 8
    };
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  const t12 = theme.palette.mode === "dark" ? logoDark.src : logoLight.src;
  let t13;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = {
      width: "100%",
      maxWidth: "80%",
      height: "auto"
    };
    $[19] = t13;
  } else {
    t13 = $[19];
  }
  let t14;
  if ($[20] !== t12) {
    t14 = <Box sx={t11}><Image alt="Keystone Logo" src={t12} width={0} height={0} style={t13} /></Box>;
    $[20] = t12;
    $[21] = t14;
  } else {
    t14 = $[21];
  }
  let t15;
  if ($[22] !== onLoginHandlerAzure || $[23] !== onLoginHandlerKUA || $[24] !== onLoginHandlerLDAP || $[25] !== onShowCompoentHandler || $[26] !== options || $[27] !== requestAccessUrl || $[28] !== showRequestAccess || $[29] !== state) {
    t15 = showRequestAccess ? <RequestAccess requestAccessUrl={requestAccessUrl} options={options} /> : <Stack spacing={4}>{state.showComponent ? <>{state.showComponent == "azure" ? <LoginWithAzure onLoginHandler={onLoginHandlerAzure} /> : null}{state.showComponent == "ldap" ? <LoginWithLdap showForm={onShowCompoentHandler} show={true} showAbort={state.showAbort} onLoginHandler={onLoginHandlerLDAP} /> : null}{state.showComponent == "kua" ? <LoginWithKua showForm={onShowCompoentHandler} show={true} showAbort={state.showAbort} onLoginHandler={onLoginHandlerKUA} /> : null}</> : <>{state.hasAzure ? <LoginWithAzure onLoginHandler={onLoginHandlerAzure} /> : null}{state.showAzureWithMore ? <Divider><Typography>or</Typography></Divider> : null}{state.hasLDAP ? <LoginWithLdap show={state.showLDAP} showForm={onShowCompoentHandler} showAbort={false} onLoginHandler={onLoginHandlerLDAP} /> : null}{state.showLDAPWithMore ? <Divider><Typography>or</Typography></Divider> : null}{state.hasKUA ? <LoginWithKua show={state.showKUA} showForm={onShowCompoentHandler} showAbort={false} onLoginHandler={onLoginHandlerKUA} /> : null}</>}</Stack>;
    $[22] = onLoginHandlerAzure;
    $[23] = onLoginHandlerKUA;
    $[24] = onLoginHandlerLDAP;
    $[25] = onShowCompoentHandler;
    $[26] = options;
    $[27] = requestAccessUrl;
    $[28] = showRequestAccess;
    $[29] = state;
    $[30] = t15;
  } else {
    t15 = $[30];
  }
  let t16;
  if ($[31] !== t14 || $[32] !== t15) {
    t16 = <Stack spacing={6} sx={t10}>{t14}{t15}</Stack>;
    $[31] = t14;
    $[32] = t15;
    $[33] = t16;
  } else {
    t16 = $[33];
  }
  let t17;
  if ($[34] !== requestAccessEnabled || $[35] !== showRequestAccess) {
    t17 = requestAccessEnabled && <Stack sx={{
      paddingBottom: 10,
      alignItems: "center"
    }}><Box sx={{
        textAlign: "center"
      }}>{showRequestAccess ? <><Typography variant="subtitle2">Already a user?</Typography><Button variant="text" onClick={() => setShowRequestAccess(false)}>Abort Request Access</Button></> : <><Typography variant="subtitle2">Do not have access yet?</Typography><Button variant="text" onClick={() => setShowRequestAccess(true)}>Request Access</Button></>}</Box></Stack>;
    $[34] = requestAccessEnabled;
    $[35] = showRequestAccess;
    $[36] = t17;
  } else {
    t17 = $[36];
  }
  let t18;
  if ($[37] !== t16 || $[38] !== t17) {
    t18 = <Grid sx={t8}><Stack sx={t9}>{t16}{t17}</Stack></Grid>;
    $[37] = t16;
    $[38] = t17;
    $[39] = t18;
  } else {
    t18 = $[39];
  }
  let t19;
  if ($[40] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <Grid sx={{
      width: {
        xs: "0",
        sm: "calc(100% - 500px)"
      },
      backgroundImage: `url('${BgImage}')`,
      backgroundSize: "cover",
      backgroundPosition: "center",
      backgroundRepeat: "no-repeat"
    }} />;
    $[40] = t19;
  } else {
    t19 = $[40];
  }
  let t20;
  if ($[41] !== t18) {
    t20 = <Grid container={true}>{t18}{t19}</Grid>;
    $[41] = t18;
    $[42] = t20;
  } else {
    t20 = $[42];
  }
  return t20;
};